import baseIcon from '../base.mjs';

const SiAdobe = baseIcon("Adobe", "#FF0000", "M13.966 22.624l-1.69-4.281H8.122l3.892-9.144 5.662 13.425zM8.884 1.376H0v21.248zm15.116 0h-8.884L24 22.624Z");
const SiAdobe$1 = SiAdobe;

export { SiAdobe$1 as default };
